module.exports = __webpack_public_path__ + "img/Controle_de_Residuos_Hospitalares.4257ada0.jpg";